import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function MaintenanceManagement() {
  return (
    <>
<Features docname="Maintenance Management"/>
<Advantages docname="Maintenance Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default MaintenanceManagement;
